// Allowed Email API functions
export const allowedEmailAPI = {
  // Get all allowed emails
  getAll: async (page = 1, limit = 10, search = "") => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
    });

    const response = await fetch(`/api/allowed-emails?${params}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "X-Session-ID": localStorage.getItem("sessionId"),
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to fetch allowed emails");
    }

    return response.json();
  },

  // Add single email
  add: async (email, notes = "") => {
    const response = await fetch("/api/allowed-emails", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "X-Session-ID": localStorage.getItem("sessionId"),
      },
      body: JSON.stringify({ email, notes }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to add email");
    }

    return response.json();
  },

  // Bulk add emails
  bulkAdd: async (emails) => {
    const response = await fetch("/api/allowed-emails/bulk", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "X-Session-ID": localStorage.getItem("sessionId"),
      },
      body: JSON.stringify({ emails }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to bulk add emails");
    }

    return response.json();
  },

  // Update email
  update: async (id, updateData) => {
    const response = await fetch(`/api/allowed-emails/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "X-Session-ID": localStorage.getItem("sessionId"),
      },
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to update email");
    }

    return response.json();
  },

  /**
   * Remove email
   * @param {string} id - The ID of the allowed email entry to remove
   * @returns {Promise<object>} - The API response
   */
  remove: async (id) => {
    const response = await fetch(`/api/allowed-emails/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "X-Session-ID": localStorage.getItem("sessionId"),
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to remove email");
    }

    return response.json();
  },

  /**
   * Revoke an invite (delete allowed email entry)
   * @param {string} id - The ID of the allowed email entry to revoke
   * @returns {Promise<object>} - The API response
   */
  revokeInvite: async (id) => {
    // Alias for remove, for clarity in UI usage
    return await allowedEmailAPI.remove(id);
  },
};
